// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__PY66N","footer":"footer_footer__m9lhr"};